export const setObject: any = (key: string, value: any = "") => {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    console.error(error);
  }
};
export const getObject: any = (key = "uuid") => {
  try {
    const result: any = localStorage.getItem(key);
    if (result) {
      try {
        return JSON.parse(result.value);
      } catch {
        return result;
      }
    }
  } catch (error) {
    console.error(error);
  }
};
export const removeObject: any = (key: string) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(error);
  }
};
